import {
    Dominio,
    type IDominioConfig,
    type ISubdominio,
    type ISubdominioCompleto,
} from "services-comun/modules/net/config/dominio";
import {immute} from "services-comun/modules/utiles/object";

export type TSite = "ar"|"at"|"bo"|"br"|"ca"|"cl"|"cr"|"de"|"do"|"ec"|"en"|"es"|"eu"|"fr"|"hn"|"it"|"mx"|"nl"|"pa"|"pe"|"pt"|"py"|"ru"|"uy"|"ve";
export type TPlataforma = "web"|"android"|"ios"|"harmony";

export interface IDominioTiempoConfig extends IDominioConfig {
    id: TSite;
    pais: number;
    idiomas: string[];
}

export class DominioTiempo extends Dominio {
    /* STATIC */
    public static readonly SERVICES: ISubdominioCompleto = immute({
        nombre: "services",
        scheme: "https",
    });

    /* INSTANCE */
    protected readonly SUBDOMINIO_SERVICES = DominioTiempo.SERVICES;

    public readonly SERVICES = this.SUBDOMINIO_SERVICES.nombre;

    public readonly id: TSite;
    public readonly idioma: string;
    public readonly idioma_corto: string;
    public readonly idiomas: string[];
    public readonly pais: number;
    public readonly servicesMR: string;

    public constructor(config: IDominioTiempoConfig, subdominios: Required<ISubdominio>[]=[]) {
        const listado = [DominioTiempo.SERVICES, ...subdominios];
        super({...config,
            subdominios: {
                listado,
                habilitados: listado.map(actual=>actual.nombre),
                redirigidos: [],
            },
        });

        this.id = config.id;
        this.idioma = config.idiomas[0];
        this.idioma_corto = this.idioma.substring(0, 2);
        this.idiomas = config.idiomas;
        this.pais = config.pais;
        if (DESARROLLO) {
            this.servicesMR = "https://local-services.meteored.com";
        } else if (TEST) {
            this.servicesMR = "https://test-services.meteored.com";
        } else {
            this.servicesMR = "https://services.meteored.com";
        }
    }
}

export {DominioTiempo as Dominio};

const tiempo = DominioTiempo;
export default tiempo;
